import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import Maybe from 'components/@common/Maybe';
import Indicator from './Indicator';
import { percentOf } from './util';

type ProgressBarProps = {
  metColor: string;
  notMetColor: string;
  metDescription?: any;
  MetEndAdornment?: any;
  notMetDescription?: any;
  NotMetEndAdornment?: any;
  descriptionWidth?: any;
  title: React.ReactNode | string;
  currentPercent: number;
};

const LargeProgressBar = ({
  metColor,
  notMetColor,
  metDescription,
  notMetDescription,
  NotMetEndAdornment,
  MetEndAdornment,
  title,
  currentPercent,
  descriptionWidth = percentOf(currentPercent, 100)
}: ProgressBarProps) => {
  const classes = useStyles();
  const showNotMet = currentPercent !== 100;

  return (
    <Box display="flex" flex={1} flexDirection="column" position="relative" marginBottom={3}>
      <Box display="flex" flexDirection="row" justifyContent="space-between" marginBottom="2px">
        {title}
      </Box>

      <Box className={classes.notMet} style={{ width: '100%', backgroundColor: notMetColor }}>
        {currentPercent > 0 && <Indicator color={metColor} style={{ height: 68 }} />}
      </Box>
      <Box
        className={classes.met}
        width={`${percentOf(currentPercent, 100)}%`}
        style={{
          backgroundColor: metColor,
          ...(currentPercent === 100 && { borderTopRightRadius: 8, borderBottomRightRadius: 8 })
        }}
      >
        <Box display="flex" flex={1}>
          <Typography style={{ color: '#fff', marginLeft: 8 }}>{currentPercent}%</Typography>
        </Box>
        <Box display="flex" marginLeft={2}>
          {currentPercent !== 100 && <Indicator color={notMetColor} />}
          <Typography style={{ color: '#fff', position: 'absolute', marginLeft: '8px' }}>
            {100 - currentPercent}%
          </Typography>
        </Box>
      </Box>

      <Box display="flex" flex={1}>
        <Box
          style={{
            display: 'flex',
            marginLeft: 11,
            fontSize: 18,
            alignItems: 'flex-end',
            marginTop: 25,
            flexWrap: 'nowrap'
          }}
        >
          <Maybe shouldRender={currentPercent > 0}>
            <>
              {metDescription}
              {MetEndAdornment}
            </>
          </Maybe>
        </Box>
        <Maybe shouldRender={showNotMet}>
          <Box
            className="notMetDescription"
            style={{
              display: 'flex',
              width: '10',
              fontSize: 18,
              marginLeft: `${+descriptionWidth + 3}%`,
              position: 'absolute',
              whiteSpace: 'nowrap',
              verticalAlign: 'center'
            }}
          >
            {notMetDescription}
            {NotMetEndAdornment}
          </Box>
        </Maybe>
      </Box>
    </Box>
  );
};

const useStyles = makeStyles(() => ({
  notMet: {
    display: 'flex',
    height: 22,
    borderRadius: '8px'
  },
  met: {
    display: 'flex',
    height: 22,
    justifyContent: 'flex-end',
    borderRadius: '8px 0px 0px 8px',
    marginTop: -22
  },
  icon: {
    marginLeft: 2
  }
}));
export default LargeProgressBar;
